import { createContext, useReducer, useEffect } from 'react';

export const CommunitiesContext = createContext();

export const communitiesReducer = (state, action) => {
  switch (action.type) {
    case 'SET_COMMUNITIES':
      return { 
        ...state,
        communities: action.payload 
      };
    case 'SET_COMMUNITY':
      return { 
        ...state,
        currentCommunity: action.payload
      };
    case 'SET_COMMUNITYNAME':
      return { 
        ...state,
        communityName: action.payload 
      };
    case 'CREATE_COMMUNITY':
      return { 
        ...state,
        communities: [action.payload, ...state.communities] 
      };
    case 'DELETE_COMMUNITY':
      return { 
        ...state,
        communities: state.communities.filter(w => w._id !== action.payload._id) 
      };
    default:
      return state;
  }
};

export const CommunitiesContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(communitiesReducer, { 
    communities: [],
    communityName: null, // Initialize with null or default name
    currentCommunity: null
  });

  // Example: Set a default community name on initial load
  useEffect(() => {
    dispatch({ type: 'SET_COMMUNITYNAME', payload: 'Beebler' });
    console.log('Context initialized');
  }, []);
  
  return (
    <CommunitiesContext.Provider value={{ ...state, dispatch }}>
      {children}
    </CommunitiesContext.Provider>
  );
};
